import { Grid } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AutocompleteDropdown } from 'src/shared/components/form/autocompleteDropdown';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { District } from 'src/shared/models/district/district';
import { SelectableItem } from 'src/shared/models/gui/selectableItem';
import { getDistricts } from 'src/shared/services/districtService';

type UserEditDistrictDropdownProps = {
  setShowDistrictDropdown: (showDropdown: boolean) => void;
};

export const UserEditDistrictDropdown = (props: UserEditDistrictDropdownProps) => {
  const { setShowDistrictDropdown } = props;
  const { t } = useTranslation(['user']);
  const isMounted = useIsMounted();
  const { setValue } = useFormContext();

  const [loading, setLoading] = useState<boolean>(false);
  const [districtData, setDistrictData] = useState<District[]>();

  const fetchDistrict = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getDistricts(0, 100, 'countyAss', 'desc');
      if (isMounted()) {
        setDistrictData(result.data.results);
      }
    } catch (e) {
      if (isMounted()) ConsoleHelper.log(e);
    } finally {
      if (isMounted()) {
        setLoading(false);
      }
    }
  }, [isMounted]);

  useEffect(() => {
    fetchDistrict();
  }, [fetchDistrict]);

  const handleSelectDistrictItem = async (val: SelectableItem | null) => {
    if (districtData && val !== null) {
      const selectedDistrict = districtData.find((item) => val.value === item.countyAss);
      if (selectedDistrict) {
        setValue('districts', [selectedDistrict]);
        setValue('associations', []);
        setShowDistrictDropdown(false);
      }
    }
  };

  return (
    <Grid container>
      <Grid item xs>
        <AutocompleteDropdown
          emptyLabel={t('user:selectDistrict')}
          placeholder={t('user:selectDistrict')}
          loading={loading}
          options={(districtData ?? []).map((x) => ({
            label: x.countyAss,
            value: x.countyAss,
          }))}
          nameProp='label'
          keyProp='value'
          name='districts'
          callback={(val) => handleSelectDistrictItem(val)}
          label={t('user:district')}
          componentWidth='100%'
        />
      </Grid>
    </Grid>
  );
};
